// extracted by mini-css-extract-plugin
export default {"alert":"BookingOverview_alert__KXdwr","cards":"BookingOverview_cards__QFMvl","cardsTop":"BookingOverview_cardsTop__B9oQc","subtitle":"BookingOverview_subtitle__oyfsH"};